import { Card } from "@icg360/design-system";

import { useEligibleCoverages } from "data/ss-data-hooks";

import { CoverageCard } from "./coverage-card";
import styles from "./extended-coverages.module.scss";
import { useCoverages } from "./hooks";

const ExtendedCoverages = () => {
  const { data, isLoading } = useEligibleCoverages();
  const coveragesToShow = useCoverages(data?.coverages);

  return !isLoading && coveragesToShow?.length ? (
    <Card title="Extended coverages">
      <div className={styles.extendedCoverages}>
        <p>
          Consider these additional coverages that protect you from risks not
          covered by your standard homeowners insurance policy.
        </p>
        {coveragesToShow.map((coverage, i) => (
          <CoverageCard
            key={i}
            coverage={coverage}
            listOfCoverages={coveragesToShow}
          />
        ))}
      </div>
    </Card>
  ) : null;
};

export default ExtendedCoverages;
